
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { EnumMyAccountExchange } from '@xt/client/enums/my'
import ExchangeList from './views/List/index.vue'
import ExchangeDetail from './views/Detail/index.vue'
import ExchangeRecord from './views/Record/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    ExchangeList,
    ExchangeDetail,
    ExchangeRecord
  }
})
export default class MyAccountExchange extends Vue {
  current: string = EnumMyAccountExchange.List
  productId: number = 0

  compMap: Record<EnumMyAccountExchange, string> = {
    [EnumMyAccountExchange.List]: 'ExchangeList',
    [EnumMyAccountExchange.Detail]: 'ExchangeDetail',
    [EnumMyAccountExchange.Record]: 'ExchangeRecord'
  }

  get EnumMyAccountExchange() {
    return EnumMyAccountExchange
  }

  get currentComp(): string {
    return this.compMap[this.current]
  }

  handleToDetail(id: number) {
    this.productId = id
    this.handleCurrentChange(EnumMyAccountExchange.Detail)
  }

  handleCurrentChange(current: EnumMyAccountExchange) {
    this.current = current

    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
